import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(cityId) {
  return yield oncallFetch("/api/oncall/partners/cities/list-regions", {
    id: cityId,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/cities/list-regions.js